import { Formik } from 'formik';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useValidator } from '../../../../utils/validators';
import SettingsDetailsForm from './SettingsDetailsForm';
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
import CircularProgress from '@material-ui/core/CircularProgress';
import { updateUser } from '../../../../actions/user-actions';
import CommonSnackbar from '../../../common/CommonSnackbar';
import Box from '@material-ui/core/Box';

const PASSWORD_MIN_LENGTH = 8;

const validator = ({ values, intl: { formatMessage } }) => {
  const errors = {};
  
  if (!values.firstName) {
    errors.firstName = formatMessage({
      id: 'form.user-settings.details.field.first-name.error.empty',
      defaultMessage: 'First name is required',
    });
  }
  
  if (!values.lastName) {
    errors.lastName = formatMessage({
      id: 'form.user-settings.details.field.last-name.error.empty',
      defaultMessage: 'Last name is required',
    });
  }
  
  if (values.newPassword && values.newPassword.length < PASSWORD_MIN_LENGTH) {
    errors.newPassword = formatMessage({
      id: 'form.user-settings.change-password.field.password.error.min.length',
      defaultMessage: 'Min 8 characters',
    });
  }
  
  if (values.newPassword && values.newPassword === values.oldPassword) {
    errors.newPassword = formatMessage({
      id: 'form.user-settings.change-password.field.new-password.error.same',
      defaultMessage: 'New password is the same as the current one',
    });
  }
  
  if (values.newPassword && !values.oldPassword) {
    errors.oldPassword = formatMessage({
      id: 'form.user-settings.change-password.field.old-password.error.empty',
      defaultMessage: 'Current password is required',
    });
  }
  if (values.newPassword && !values.confirmPassword) {
    errors.confirmPassword = formatMessage({
      id: 'form.user-settings.change-password.field.confirm-password.error.empty',
      defaultMessage: 'Confirm new password is required',
    });
  } else if (values.confirmPassword !== values.newPassword) {
    errors.confirmPassword = formatMessage({
      id: 'form.user-settings.change-password.field.confirm-password.error.mismatch',
      defaultMessage: 'Must be the same as the new password',
    });
  }
  
  return errors;
};

const SettingsDetails = React.forwardRef((props, ref) => {
  const formValidator = useValidator(validator);
  const { user, updateUser } = props;
  const [isAccountUpdated, setIsAccountUpdated] = React.useState(false);
  
  const handleSnackbarClose = () => {
    setIsAccountUpdated(false);
  };
  
  if (!user) {
    return <CircularProgress />;
  }
  return (
    <Box display={'flex'} flexDirection={'column'} justifyContent={'center'} alignItems={'center'}>
      <h1>
        <FormattedMessage
          id="page.user-settings.details.title"
          defaultMessage="Account details"
        />
      </h1>
    
      <Formik
        enableReinitialize
        initialValues={{
          username: user.UserName,
          email: user.EMail,
          firstName: user.Firstname,
          lastName: user.Lastname,
          oldPassword: '',
          newPassword: '',
          confirmPassword: '',
        }}
        validate={formValidator}
        component={SettingsDetailsForm}
        onSubmit={(values, formikHelpers) => {
          updateUser(values, formikHelpers, setIsAccountUpdated);
        }}
      />
    
      {isAccountUpdated && <CommonSnackbar
        open={true}
        title={<FormattedMessage id="success" defaultMessage="Success" />}
        message={<FormattedMessage id="account.details.saved" defaultMessage="Account details saved!" />}
        onExtraClose={handleSnackbarClose}
      />}
    </Box>
  );
});

const decorate = compose(
  connect(
    store => ({ user: store.user.profile }),
    dispatch => bindActionCreators({ updateUser }, dispatch)),
);

export default decorate(SettingsDetails);
